module.exports = __webpack_public_path__ + "assets/GoldOmega2x.6ea56eb4681229396a90b94860942813.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldOmega2x.png
// module id = 816
// module chunks = 0